/* Arrow buttons for mk-* scroll tracks. The track itself is CSS scroll-snap,
   so swiping works with no JS; this only adds the desktop arrows. */
(() => {
  if (window.mkCarouselReady) return;
  window.mkCarouselReady = true;

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-mk-arrows] .mk-arrow');
    if (!btn) return;
    const section = btn.closest('section');
    const track = section && section.querySelector('[data-mk-track]');
    if (!track) return;
    const card = track.firstElementChild;
    const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    track.scrollBy({ left: step * Number(btn.dataset.dir || 1), behavior: 'smooth' });
  });
})();
